import React, { useState } from "react";
import { PageHeader } from "antd";
import JcpEnrollmentEntry from "../../components/enrollment/jcp/JcpEnrollmentEntry";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import JcpEnrollmentEntryMonthly from "../../components/enrollment/jcp/JcpEnrollmentEntryMonthly";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const JcpEnrollmentMonthly = () => {
  const params = useParams();
  const [heading,setHeading] = useState("");

  useEffect(()=>{
    if(params.billtype){
      params.billtype == "gst" ? setHeading("Monthly Subscription JCP (GST)") : setHeading("Monthly Subscription JCP (NON-GST)");
    }
  },[params.billtype]);
 

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={heading}
          subTitle=""
          extra={[]}
        ></PageHeader>

        <JcpEnrollmentEntryMonthly />
      </div>
    </div>
  );
};

export default JcpEnrollmentMonthly;
